// extracted by mini-css-extract-plugin
module.exports = {"bg":"Case_bg__1nWsP","title":"Case_title__3XqzE","box":"Case_box__274-c","btn":"Case_btn__16vhF","btn_1":"Case_btn_1__1MxZw"};